import { render, staticRenderFns } from "./download_nx.vue?vue&type=template&id=2e8ff71e&scoped=true&"
import script from "./download_nx.vue?vue&type=script&lang=js&"
export * from "./download_nx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8ff71e",
  null
  
)

export default component.exports